import React, { Component } from "react";
import TrackingReportForm from "../TrackingReportForm/TrackingReportForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : SupportPage
Description : Componente que contienen el formulario de la pantalla Support 
Date Autor Modification
================================================================================
26/10/2021 Santiago Coca Rojas Creación – Se llama al componente ReportedForm
================================================================================ */
class TrackingReportPage extends Component {
    render() {
        return (
            <div>
                <TrackingReportForm />
            </div>
        )
    }
}

export default TrackingReportPage;